module.exports = __webpack_public_path__ + "static/img/official.2d14a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/official.jpg
// module id = tJIc
// module chunks = 1